module.exports = __webpack_public_path__ + "img/thumbs-down.aa2e7dd1.svg";